import { HotspotRenderer } from './renderers/HotspotRenderer';
import { ArrowPosition } from '@ael/core-api';
import { HotspotStyle, PanoramaHotspot, PanoramaRenderApi } from '@ael/core-api';

export class ManagerPolygonalHotspot extends PanoramaHotspot {
  private _hotspotRenderer: HotspotRenderer;

  constructor(name: string, points: ArrowPosition[], onClick?: () => void) {
    super(name);
    this._hotspotRenderer = new HotspotRenderer(name, HotspotStyle.HotspotPolygonalManager, points, onClick);
  }

  render(pano: PanoramaRenderApi) {
    this._hotspotRenderer.render(pano);
  }
}
